import {Component, Input} from '@angular/core';
import {LocaleService} from '../../../services/locale/locale.service';
import {Formats} from '../../../constants/formats';
import {Proposal} from '../../../model/proposal/proposal';

@Component({
    selector: 'app-insurance-contract-detail-sum-insureds',
    templateUrl: './insurance-contract-detail-sum-insureds.component.html',
    standalone: false
})
export class InsuranceContractDetailSumInsuredsComponent {

  @Input() proposal: Proposal;

  constructor(
    public readonly localeService: LocaleService
  ) {
  }

  Formats = Formats;

}
